/** True for touch-primary phones/tablets where keyboard + mouse are not expected. */
export function isMobileDevice(): boolean {
  if (window.matchMedia("(hover: none) and (pointer: coarse)").matches) {
    return true;
  }
  const ua = navigator.userAgent || "";
  if (!/Android|iPhone|iPod|iPad|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
    return false;
  }
  if (/iPhone|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
    return true;
  }
  // iPadOS 13+ may report as Mac; touch points still indicate a tablet.
  return navigator.maxTouchPoints > 1;
}
